import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

// Fetch the computed setup checklist progress for the current user's workspace
const getProgress = async () => {
  const token = await firebase.auth().currentUser.getIdToken()

  const { data } = await AxiosConfig.get('/setup/progress', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

// Record a checklist step the server can't detect itself (the demo Lens
// walkthroughs). The server only accepts whitelisted step ids.
const stamp = async (stepId) => {
  const token = await firebase.auth().currentUser.getIdToken()

  const { data } = await AxiosConfig.post('/setup/stamp', { stepId }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const skip = async (stepId, skipped = true) => {
  const token = await firebase.auth().currentUser.getIdToken()

  const { data } = await AxiosConfig.post('/setup/skip', { stepId, skipped }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

export default {
  getProgress,
  stamp,
  skip
}
